<template>
  <div style="background-color: rgba(255,235,219,0.27); padding: 10px;">
    <div class="bottom-right-container">
      <h3 style="margin: 30px">维修类型：</h3>
      <el-form ref="originForm" :model="originForm" label-width="120px" :rules="rules">
        <el-row style="margin-top: -50px; margin-left: -150px">
          <el-radio-group @change="confirm()" v-model="originForm.afterSalesType">
            <el-radio label="返厂维修"></el-radio>
            <el-radio label="自主维修"></el-radio>
          </el-radio-group>
        </el-row>
        <div class="floating-link">
          <a href="https://mangkeyi.yuque.com/tluy7x/rpi080/yv7qrecpy22tw1yc" target="_blank">使用教程</a>
        </div>
      </el-form>
      <div class="bottom-container_two">
        <div class="bottom-right-container">
          <div>
            <!--            <h3>自主维修：</h3>-->
            <div style="padding: 10px 6px 0px 6px">

              <el-form style="margin-bottom: 20px;">
                <el-row>
                  <el-col :span="12">
                    <el-input style="width: 360px; margin-left: -40px" v-model="phoneIMEI" placeholder="请输入或扫描IMEI码" @input="phoneIMEIIn"></el-input></el-col>
                  <el-col :span="12">
                    <el-button style="margin-left: -340px" type="primary" @click="toTakePhoto(8)">拍照识别IMEI码</el-button>
                  </el-col></el-row>
              </el-form>

              <el-form ref="phoneForm" :rules="rules" :model="phoneForm" label-width="100px">
                <el-row :gutter="185">
                  <el-col :span="12">
                    <el-form-item label="手机品牌:" prop="phoneBrand">
                      <el-select v-model="phoneForm.phoneBrand" :disabled="true">
                        <el-option v-for="(data, index) in Array.from(
                          new Set(this.phoneBrandList)
                        )" :key="index" :value="data" :label="data" class="input"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="颜色:" prop="phoneColor">
                      <el-select v-model="phoneForm.phoneColor" :disabled="true">
                        <el-option v-for="(data, index) in Array.from(
                          new Set(this.phoneColorList)
                        )" :key="index" :value="data" :label="data"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="型号:" prop="phoneName">
                      <el-select :disabled="true" v-model="phoneForm.phoneName" @change="queryPhoneColorList">
                        <el-option v-for="(data, index) in Array.from(
                          new Set(this.phoneNameList)
                        )" :key="index" :value="data" :label="data" class="input"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="订单码" prop="orderId">
                      <el-input :disabled="true" v-model="phoneForm.orderId" style="width: 220px"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <!--                    <el-form-item label="原因" prop="reason">-->
                    <!--                      <el-input v-model="phoneForm.reason" style="width: 220px"></el-input>-->
                    <!--                    </el-form-item>-->
                    <el-form-item label="原因:" prop="phoneBrand">
                      <el-select
                      v-model="phoneForm.reason"
                      style="width: 222px;  height: 36px;"
                    >
                      <el-option
                        v-for="(data, index) in options"
                        :key="index"
                        :value="data"
                        :label="data"
                      ></el-option>
                    </el-select>
                    </el-form-item>
                  </el-col>
                  <el-form-item label="IMEI2:" prop="IMEI2Name" style="display: none">
                    <el-input v-model="phoneForm.IMEI2Name" style="width: 220px"></el-input>
                  </el-form-item>

                  <el-col :span="12">
                    <el-form-item label="客户电话" prop="phone">
                      <el-input v-model="phoneForm.phone" style="width: 220px"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="客户地址" prop="site">
                      <el-input type="textarea" v-model="phoneForm.site" style="width: 220px"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-button style="margin-top: 20px; margin-left: 210px;"  type="primary" @click="print(ReturnTextPrintData)"
                    v-loading.fullscreen.lock="fullscreenLoading">打印并提交</el-button>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="拍照" :visible.sync="takePhotoVisible" width="60%" height="320px" @opened="CZUR_ID_OpenDevice"
      @close="handleClose">
      <div class="video-container">
        <el-row>
          <canvas ref="m_cav_frame" style="background: black; width: 90%; height: auto" id="mframe" width="640"
            height="480"></canvas>
          <!-- <video ref="videoElement"  style="width: 100%;" autoplay></video> -->
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">取 消</el-button>
        <el-button type="primary" @click="CZUR_ID_GrabBase64">拍照</el-button>
        <!-- <el-button type="primary" @click="takePhoto">拍照</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showPicPreview" width="60%">
      <img :src="picPreview" alt="Preview" style="width: 100%" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="retakePhoto">重拍</el-button>
        <el-button type="primary" @click="showPicPreview = false">取消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import axios from "axios";
import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { ReturnTextPrintData } from "@/utils/printData/ReturnTextMy";
import { client } from "@/utils/alioss.js";
export default {
  //创建自定义事件
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const rect = this.getBoundingClientRect();
          const isAtBottom = rect.bottom <= window.innerHeight;
          if (isAtBottom) {
            binding.value();
          }
        });
      },
    },
  },
  data() {
    const jsonObj = {
      printerImageProcessingInfo: {
        printQuantity: 1,
      },
    };
    return {
      userId: 1940693,
      options: [],
      partsPage: 1,
      partsSize: 200,
      partsAmount: 1,
      fullscreenLoading: false,
      closeNum: '',
      j_img_base64: new Image(),
      m_img_frame: new Image(),
      //指令通道信息
      cmd_svc_connect: false,
      cmd_svc_port: 25014,
      ws_cmd: null,
      txtlog: "",
      //记录主头处理方式
      m_process_type: 0,
      //是否绘制主头视频画面
      is_draw_m_frame: false,
      //主头通道信息
      ws_mc: null,
      mc_svc_port: 9999,
      mc_svc_connect: false,
      //记录主头手动框选裁剪得矩形框
      m_left: 0.2,
      m_top: 0.2,
      m_right: 0.8,
      m_bottom: 0.8,
      m_cav_frame: "",
      m_ctx_frame: "",
      showPicPreview: false,
      reTakePhoneNum: "",
      picPreview: "",
      phoneIMEI: "",
      takePhotoVisible: false,
      rotation: 0, // 旋转的角度
      isScreenValid: true, // 标记输入字段是否有效
      usernameError: "", // 存放错误消息
      custom1picText: "",
      custom2picText: "",
      custom3picText: "",
      rules: {
        phoneBrand: [
          { required: true, message: "请选择手机品牌", trigger: "change" },
        ],
        phoneName: [
          { required: true, message: "请选择手机型号", trigger: "change" },
        ],
        phoneColor: [
          { required: true, message: "请选择手机颜色", trigger: "change" },
        ],
        phoneMemory: [
          { required: true, message: "请选择手机内存", trigger: "change" },
        ],
        SNName: [{ required: true, message: "请输入序列号", trigger: "blur" }],
        // IMEI2Name: [
        //   { required: true, message: '请输入型号号码', trigger: 'blur' }
        // ],
        IMEIName: [
          { required: true, message: "请输入IMEI码", trigger: "blur" },
        ],
        afterSalesType: [
          { required: true, message: "请选择维修类型", trigger: "change" },
        ],
      },

      barCodeNum: "",
      phoneBrandList: [],
      phoneNameList: [],
      phoneColorList: [],
      phoneMemoryList: [],
      phoneOldList: ["99新", "95新", "9成新", "8成新"],
      TipsList: ["原屏原电", "换屏换电", "原屏换电", "换屏原电"],
      phoneForm: {},
      scanBarcodeIn: "",
      jsonObj,
      printVisible: false,
      cropperVisible: false,
      cropperLoading: false,
      previewImg: "",
      isPreview: false,
      // 打印服务是否连接成功
      printSocketOpen: false,
      ReturnTextPrintData,
      barCodeList: [],
      barCodePrintList: [],
      barcodePrintFlag: false,
      nMPrintSocket: null,
      usbPrinters: {},
      usbSelectPrinter: "",
      onlineUsbBool: false,
      initBool: false,
      recognizedText: [],
      SNflag: false,
      IMEIflag: false,
      batteryflag: false,
      screenflag: false,
      backflag: false,
      leftflag: false,
      rightflag: false,
      topflag: false,
      bottomflag: false,
      custom1flag: false,
      custom2flag: false,
      custom3flag: false,
      custom1Data: {},
      custom2Data: {},
      custom3Data: {},
      SNData: {},
      IMEIData: {},
      batteryData: {},
      screenData: {},
      backData: {},
      leftData: {},
      rightData: {},
      topData: {},
      bottomData: {},
      density: 3,
      label_type: 1,
      print_mode: 1,
      picText: "",
      photoDataUrl: null,
      crooperedPic: "",
      crooperoption: {
        canMove: false,
        zoomable: false,
        canMoveBox: true,
        autoCrop: true,
        img: "", // 裁剪图片的地址
        centerBox: true, // 截图框是否被限制在图片里面
      },
      SNoptions: [{ value: "序列号", label: "序列号" }],
      IMEIoptions: [{ value: "IMEI码", label: "IMEI码" }],
      batteryOptions: [{ value: "电池容量", label: "电池容量" }],
      screenOptions: [
        { value: "完好", label: "完好" },
        { value: "使用痕迹", label: "使用痕迹" },
        { value: "划痕", label: "划痕" },
        { value: "磕碰", label: "磕碰" },
      ],
      backOptions: [
        { value: "背板完好", label: "背板完好" },
        { value: "背板磕碰", label: "背板磕碰" },
        { value: "摄像头完好", label: "摄像头完好" },
        { value: "背板使用痕迹", label: "背板使用痕迹" },
        { value: "背板划痕", label: "背板划痕" },
        { value: "摄像头磨损", label: "摄像头磨损" },
        { value: "摄像头使用痕迹", label: "摄像头使用痕迹" },
        { value: "摄像头磕碰", label: "摄像头磕碰" },
      ],
      value: "",
      currentPage: 1,
      pageSize: 200,
      originVisible: false,
      originForm: {
        afterSalesType: '自主维修'
      },

    };
  },
  computed: {
    imageStyle() {
      return {
        transform: `rotate(${this.rotation}deg)`,
      };
    },
  },
  watch: {
    phoneIMEI(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.phoneIMEIIn();
        // this.orderInfo();
      }
    }
  },
  mounted() {
    // this.startCamera();
    // this.initCamera();
    // this.m_cav_frame = this.$refs.m_cav_frame;
    // this.m_ctx_frame = this.m_cav_frame.getContext("2d")
    // 创建socket实例
    const socketData = new Socket("ws://127.0.0.1:37989");

    socketData.open(
      (openBool) => {
        console.log(openBool, "openBool");
        this.printSocketOpen = openBool;
      },
      (msg) => {
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info;
          if (callbackName == "onCoverStatusChange") {
            //盒盖状态：0-闭合、1-打开
            console.log("盒盖状态", msgInfo.capStatus);
          } else if (callbackName == "onElectricityChange") {
            //"power" : 0-4, // 电池电量等级（共5档）
            console.log("电池电量等级", msgInfo.power);
          }
        }
      }
    );
    // 创建打印实例
    this.nMPrintSocket = new NMPrintSocket(socketData);
  },
  created() {
    this.SNData.picText = this.SNoptions[0].value;
    this.IMEIData.picText = this.IMEIoptions[0].value;
    this.batteryData.picText = this.batteryOptions[0].value;
    this.openCamera();
    this.originVisible = true
    this.login();
    this.obtainPJInfo();
  },
  methods: {
    login() {
      const currentUrl = window.location.toString();
      const urlObject = new URL(currentUrl);
      const searchParams = new URLSearchParams(urlObject.search);
      const userId = searchParams.get("qfExtUserId");
      if (userId != null || userId != undefined) {
        this.userId = userId;
      }
      console.log("userid:", this.userId);
      // 创建一个新的 Axios 实例专用于 /orderListApi 请求
      const loginApiInstance = axios.create({
        baseURL: "/loginApi",
      });
      //使用FormData对象发送POST请求
      loginApiInstance
        .get("monkeyshop/user/login/" + this.userId)
        .then((res) => {
          // this.tableData = res.data.data;
          if (res.data.code == 200) {
          } else {
            alert(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    obtainPJInfo() {
      console.log(2222)
      this.options = [];
      if (this.partsPage <= this.partsAmount) {
        let params = {
          userId: this.userId,
          pageSize: this.partsSize,
          pageNum: this.partsPage,
        };
        const searchPhoneInfo = axios.create({
          baseURL: "colorListApi",
          "Content-Type": "application/json",
        });

        searchPhoneInfo
          .post("monkeyshop/common/GetRepairReasonConfigService", params)
          .then((res) => {
            console.log(111)
            console.log("原因", res);
            this.partsAmount = res.data.data.pageAmount;
            res.data.data.partsList.forEach((element) => {
              this.options.push(element);
            });
          })
          .catch(function (error) {
            console.log(error);
          });

      }
    },

    // 下拉列表触底事件
    selectLoadMoreSnInfo() {
      console.log("下拉框到底触发");
      this.currentPage += 1;
    },
    async openCamera() {
      try {
        await this.connect_cmd_svc();
        await this.connect_mc_svc();
      } catch (error) {
        console.error("Error occurred while connecting services:", error);
        // 在这里处理错误
      }
    },
    connect_cmd_svc() {
      if (this.cmd_svc_connect == true) {
        alert("已连接指令服务器");
        return;
      }

      var url = "ws://127.0.0.1:" + this.cmd_svc_port + "/";
      if ("WebSocket" in window) {
        this.ws_cmd = new WebSocket(url);
      } else if ("MozWebSocket" in window) {
        this.ws_cmd = new MozWebSocket(url);
      } else {
        alert("浏览器不支持WebSocket");
      }

      this.cmdWebSocketEvent();
    },

    cmdWebSocketEvent() {
      this.ws_cmd.onopen = () => {
        this.cmd_svc_connect = true;
        this.txtlog = "成功连接指令服务器\r\n" + this.txtlog;
      };

      this.ws_cmd.onclose = () => {
        this.cmd_svc_connect = false;
        this.txtlog = "与指令服务器连接中断\r\n" + this.txtlog;
      };

      this.ws_cmd.onmessage = (e) => {
        const jsonObj = JSON.parse(e.data);
        switch (jsonObj.id) {
          //视频帧准备好
          case 119:
            this.CZUR_ID_GetFileBase64_Response(jsonObj);
            break;
          case 331:
            this.CZUR_ID_DataReady_Response(jsonObj);
            break;
          //删除本地文件反馈
          case 41:
            this.CZUR_ID_DeleteFile_Response(jsonObj);
            break;

          //处理json数据包失败反馈
          case 0:
            var error = jsonObj.error;

            switch (error) {
              case 3:
                this.txtlog =
                  "系统内存不足，无法处理当前指令\r\n" + this.txtlog;
                break;

              case 5:
                this.txtlog = "无效的json指令格式\r\n" + this.txtlog;
                break;
            }

            break;

          //初始化CZURPlugin环境反馈
          case 2:
            this.CZUR_ID_Initialize_Response(jsonObj);
            break;

          //清除CZURPlugin环境反馈
          case 4:
            this.m_process_type = 0;
            this.is_draw_m_frame = false;
            this.m_ctx_frame.fillStyle = "#000000";
            this.m_ctx_frame.beginPath();
            this.m_ctx_frame.fillRect(
              0,
              0,
              m_cav_frame.width,
              m_cav_frame.height
            );
            this.m_ctx_frame.closePath();

            this.CZUR_ID_Deintialize_Response(jsonObj);
            break;

          // //获取设备型号反馈
          // case 6:
          //   CZUR_ID_GetDeviceModel_Response(jsonObj);
          // break;

          // //获取设备ID反馈
          // case 8:{
          //   CZUR_ID_GetDeviceID_Response(jsonObj);
          // }
          // break;

          //打开设备反馈
          case 10:
            {
              this.CZUR_ID_OpenDevice_Response(jsonObj);
            }
            break;

          //关闭设备反馈
          case 12:
            {
              this.CZUR_ID_CloseDevice_Response(jsonObj);
            }
            break;

          //拍照保存图像文件反馈
          case 14:
            {
              CZUR_ID_GrabImage_Response(jsonObj);
            }
            break;



          //设置旋转角度反馈
          case 18: {
            this.CZUR_ID_SetAngle_Response(jsonObj);
          }
            break;



          //拍照(BASE64编码数据)反馈
          case 69:
            {
              this.CZUR_ID_GrabBase64_Response(jsonObj);
            }
            break;


          //停止录像反馈
          case 134:
            {
              this.CZUR_ID_StopRecord_Response(jsonObj);
            }
            break;



          //拍照(BASE64编码数据)结果通知
          case 318:
            {
              this.CZUR_ID_BASE64(jsonObj);
            }
            break;
          case 150:
            {
              CZUR_ID_GetSSCOption2_Response(jsonObj);
            }
            break;
          case 152:
            {
              CZUR_ID_GetSSCOption3_Response(jsonObj);
            }
            break;
          case 154:
            {
              CZUR_ID_SelectFolder_Response(jsonObj);
            }
            break;
          case 156:
            {
              CZUR_ID_SelectFile_Response(jsonObj);
            }
            break;
          case 330:
            {
              CZUR_ID_SelectResult_Response(jsonObj);
            }
            break;
          case 146:
            {
              CZUR_ID_Stop_Face_Live_Response(jsonObj);
            }
            break;
          case 164:
            {
              CZUR_ID_SP_Evaluate_Response(jsonObj);
            }
            break;
          case 334:
            {
              CZUR_EVENT_EVA_Status_Reply(jsonObj);
            }
            break;
          case 166:
            {
              CZUR_ID_Checkfile_Reply(jsonObj);
            }
            break;
          case 168:
            {
              CZUR_ID_CheckFolder_Reply(jsonObj);
            }
            break;
          case 170:
            {
              CZUR_ID_GetFilesUnderFolder_Reply(jsonObj);
            }
            break;
        }
      };
      console.log(this.txtlog, "指令");
    },
    connect_mc_svc() {
      if (this.mc_svc_connect == true) {
        alert("已连接主头服务器");
        return;
      }

      var url = "ws://127.0.0.1:" + this.mc_svc_port + "/";

      if ("WebSocket" in window) {
        this.ws_mc = new WebSocket(url);
      } else if ("MozWebSocket" in window) {
        this.ws_mc = new MozWebSocket(url);
      } else {
        alert("浏览器不支持WebSocket");
      }
      this.mcWebSocketEvent();
    },
    mcWebSocketEvent() {
      this.ws_mc.onopen = () => {
        this.mc_svc_connect = true;
        this.txtlog = "成功连接主头服务器\r\n" + this.txtlog;
        this.CZUR_ID_Initialize();
        // this.CZUR_ID_OpenDevice()
      };

      this.ws_mc.onclose = () => {
        this.is_draw_m_frame = false;
        this.mc_svc_connect = false;
        this.txtlog = "与主头服务器连接中断\r\n" + this.txtlog;
      };

      this.ws_mc.onmessage = (e) => {
        console.log(this.is_draw_m_frame);
        if (this.is_draw_m_frame) {
          this.m_cav_frame = this.$refs.m_cav_frame;
          this.m_ctx_frame = this.m_cav_frame.getContext("2d");
          const m_img_frame = new Image();
          m_img_frame.crossOrigin = "anonymous";
          m_img_frame.src = "data:image/jpeg;base64," + e.data;

          m_img_frame.onload = (e) => {
            // console.log(m_img_frame,'m_img_frame')
            // console.log(this.m_cav_frame.width,'this.m_cav_frame.width')
            // console.log(this.m_cav_frame.height,'this.m_cav_frame.height')
            this.m_ctx_frame.drawImage(
              m_img_frame,
              0,
              0,
              this.m_cav_frame.width,
              this.m_cav_frame.height
            );

          };
        }
      };
    },
    //设置旋转角度，格式：{"id": 17, "angle": 旋转角度}
    CZUR_ID_SetAngle() {
      var angle = 90;
      var jsonMsg = {
        id: 17,
        angle: angle
      };
      this.ws_cmd.send(JSON.stringify(jsonMsg));
      console.log('进来了旋转90')
      // this.m_cav_frame = this.$refs.m_cav_frame;
      // this.m_ctx_frame = this.m_cav_frame.getContext("2d");
    },
    //设置旋转角度反馈，格式：{"id": 18, "error": 错误代码}
    CZUR_ID_SetAngle_Response(jsonObj) {
      console.log(jsonObj, 'jsonObj')
      var error = jsonObj.error;

      switch (error) {
        case 0: {

          //获取当前用户设置的旋转角度
          var angle = 90;
          console.log(this.m_ctx_frame, 'm_ctx_frame')
          this.m_ctx_frame.restore();

          //清空画布
          this.m_ctx_frame.clearRect(0, 0, this.m_cav_frame.width, this.m_cav_frame.height);

          //设置旋转中心点
          var x = this.m_cav_frame.width / 2;
          var y = this.m_cav_frame.height / 2;

          this.m_ctx_frame.save();
          this.m_ctx_frame.translate(x, y);
          this.m_ctx_frame.rotate(angle * Math.PI / 180);
          if ((angle == 90) || (angle == 270)) {
            this.m_ctx_frame.scale(y / x, y / x);
          }
          else {
            this.m_ctx_frame.scale(1, 1);
          }
          this.m_ctx_frame.translate(-x, -y);

          this.txtlog = "设置旋转角度成功\r\n" + this.txtlog;
        } break;

        case 8: {
          this.txtlog = "CZURPlugin环境未初始化\r\n" + this.txtlog;
        } break;

        case 14: {
          this.txtlog = "摄像头尚未打开\r\n" + this.txtlog;
        } break;

        case 22: {
          this.txtlog = "无效的旋转角度\r\n" + this.txtlog;
        } break;
      }
    },
    CZUR_ID_GetFileBase64_Response(jsonObj) {
      var error = jsonObj.error;

      switch (error) {
        case 0:
          {
            this.txtlog = "获取文件base64成功\r\n" + this.txtlog;
            // var j_cav_base64 = document.getElementById("base64img");
            // var j_ctx_base64 = j_cav_base64.getContext("2d");
            var j_img_base64 = new Image();
            j_img_base64.crossOrigin = "anonymous";
            j_img_base64.src = "data:image/jpeg;base64," + jsonObj.base64;

            // j_img_base64.onload = function(e)
            // {
            //   j_ctx_base64.drawImage(j_img_base64, 0, 0, j_cav_base64.width, j_cav_base64.height);
            // }
          }
          break;
        case 8:
          {
            this.txtlog = "文件名无效\r\n" + this.txtlog;
          }
          break;
        case 2:
          {
            this.txtlog = "CZURPlugin未初始化\r\n" + this.txtlog;
          }
          break;
        case 33:
          {
            this.txtlog = "加载文件失败\r\n" + this.txtlog;
          }
          break;
        case 34:
          {
            this.txtlog = "获取文件大小失败\r\n" + this.txtlog;
          }
          break;
        case 79:
          {
            this.txtlog = "文件储存过大，暂不支持\r\n" + this.txtlog;
          }
          break;
        case 3:
          {
            this.txtlog = "系统内存不足\r\n" + this.txtlog;
          }
          break;
        default:
          {
            this.txtlog = "异常错误\r\n" + this.txtlog;
          }
          break;
      }
    },
    DrawRect(index) {
      //主头区域
      if (index == 0) {
        this.m_ctx_frame.shadowBlur = 5;
        this.m_ctx_frame.shadowColor = "rgba(0,0,0,0.5)";
        this.m_ctx_frame.strokeStyle = "#FF0000";
        this.m_ctx_frame.lineWidth = 2;
        this.m_ctx_frame.beginPath();
        // this.m_ctx_frame.rect(m_left, m_top, m_right - m_left, m_bottom - m_top);
        this.m_ctx_frame.stroke();
      }
      // else //副头区域
      // {
      //   s_ctx_frame.shadowBlur = 5;
      //   s_ctx_frame.shadowColor = "rgba(0,0,0,0.5)";
      //   s_ctx_frame.strokeStyle = "#FF0000";
      //   s_ctx_frame.lineWidth = 2;
      //   s_ctx_frame.beginPath();
      //   s_ctx_frame.rect(s_left, s_top, s_right - s_left, s_bottom - s_top);
      //   s_ctx_frame.stroke();
      // }
    },
    DrawMLine() {
      this.m_ctx_frame.shadowBlur = 5;
      this.m_ctx_frame.shadowColor = "rgba(0,0,0,0.5)";
      this.m_ctx_frame.strokeStyle = "#00FF00";
      this.m_ctx_frame.lineWidth = 2;
      this.m_ctx_frame.beginPath();
      this.m_ctx_frame.moveTo(m_x1, m_y1);
      this.m_ctx_frame.lineTo(m_x2, m_y2);
      this.m_ctx_frame.lineTo(m_x3, m_y3);
      this.m_ctx_frame.lineTo(m_x4, m_y4);
      this.m_ctx_frame.lineTo(m_x1, m_y1);
      this.m_ctx_frame.stroke();
    },

    //打开设备反馈，格式：{"id": 10, "error": 错误代码}
    CZUR_ID_OpenDevice_Response(jsonObj) {
      var error = jsonObj.error;

      switch (error) {
        case 0:
          {
            var index = 0;
            if (0 == index) {
              this.is_draw_m_frame = true;
            } else if (2 == index) {
              this.is_draw_ir_frame = true;
            } else {
              this.is_draw_s_frame = true;
            }
            this.txtlog = "打开摄像头成功\r\n" + this.txtlog;
            this.CZUR_ID_SetAngle();
            this.m_cav_frame = this.$refs.m_cav_frame;
            this.m_ctx_frame = this.m_cav_frame.getContext("2d");
          }
          break;

        case 1:
          {
            this.txtlog = "异常错误\r\n" + this.txtlog;
          }
          break;

        case 8:
          {
            this.txtlog = "CZURPlugin环境未初始化\r\n" + this.txtlog;
          }
          break;

        case 10:
          {
            this.txtlog = "设备不支持副摄像头\r\n" + this.txtlog;
          }
          break;

        case 11:
          {
            this.txtlog = "无效的摄像头序号\r\n" + this.txtlog;
          }
          break;

        case 12:
          {
            this.txtlog = "摄像头已打开\r\n" + this.txtlog;
          }
          break;

        case 13:
          {
            this.txtlog = "设备未连接，请将设备连接电脑\r\n" + this.txtlog;
          }
          break;
      }
    },
    //拍照保存JPG图像数据(BASE64编码)反馈，格式: {"id": 69, "error": 错误代码}
    CZUR_ID_GrabBase64_Response(jsonObj) {
      var error = jsonObj.error;

      switch (error) {
        case 0:
          {
            this.txtlog = "拍照成功，图像正在处理，请稍后\r\n" + this.txtlog;
          }
          break;

        case 1:
          {
            this.txtlog = "异常错误\r\n" + this.txtlog;
          }
          break;

        case 3:
          {
            this.txtlog = "系统内存不足\r\n" + this.txtlog;
          }
          break;

        case 4:
          {
            this.txtlog = "录像期间，无法拍照\r\n" + this.txtlog;
          }
          break;

        case 8:
          {
            this.txtlog = "CZURPlugin环境未初始化\r\n" + this.txtlog;
          }
          break;

        case 10:
          {
            this.txtlog = "设备不支持某些拍照属性参数设置\r\n" + this.txtlog;
          }
          break;

        case 11:
          {
            this.txtlog = "无效的摄像头序号\r\n" + this.txtlog;
          }
          break;

        case 14:
          {
            this.txtlog = "摄像头尚未打开，无法进行拍照操作\r\n" + this.txtlog;
          }
          break;

        case 17:
          {
            this.txtlog = "无效的颜色模式\r\n" + this.txtlog;
          }
          break;

        case 19:
          {
            this.txtlog = "激光线闪过之后，才可以拍摄下一张\r\n" + this.txtlog;
          }
          break;

        case 21:
          {
            this.txtlog = "无效的JPG压缩质量\r\n" + this.txtlog;
          }
          break;

        case 50:
          {
            this.txtlog = "图像数据尚未准备好，请稍后再试\r\n" + this.txtlog;
          }
          break;
      }
    },
    CZUR_ID_DataReady_Response(jsonObj) {
      this.txtlog = "视频帧准备就绪\r\n" + this.txtlog;
    },
    //初始化CZURPlugin环境，格式: {"id": 1, "license": "授权码"}
    CZUR_ID_Initialize() {
      var license =
        "piGkaOebTe+FqXPJDXa0dgVleor1YkzU6PtwAqL+FR0pRAeny4RS4UoGhkl4qxE/TMWMFo0pTSNvPbCUA9451EI2k+nOCcL9BM0Y8U3VzT/Hgej+ldixsJjn0ZDBdT//KhvZfT5NwU90rYcKhtAFbJgMOGyJPoMdsYPuyZqQIIA42vXjA2DZst6s3k4xprVtKH7pKNadZlyqiFN9awGDI1yI2tsIWW1AluZuRFNccnJWJrPf+X3rpJUUrUMKJ+qoCiWNgWYRRq/ZEYt+i1MN7Ni98U3s/vhRNdOVa4sav5m64sqqcv7kZbaJvtBwV7FeWa0eyRlUCNYAo9Xxsp3VwJOuF6WOF/IrBU0SwgnMEOPmBVnNQH+3EZntLEWFoLB78XZxf4LhmuUtiWXNMGWFobSJrKyHaIyKhCXZDv5xoi+6i50aqy/tQPHFLOqR+abY40WuS0i2rSZaA8gSq+zS90aZZBa6+HQRIGNn6qeHP0126rPKnZG+nL8wFymttjGdrgmpjjlH+J+14RkGQ2Ufxm80siDhhmESzehYPOgjk56G74gqBC8ER5Li61EdQkWGaazm26rLUknntJod8KGTj0U+kqJDJj+kYodT0qBnFQ6Yh+CPXOF7EHUH8mF9w2oN+6A2UmgH5VQ8YZO6y90rfUJrkFY3OYPDBovbZuLvFRuYDsxOXiJdSLOWwtN8hb2+7eBYseV8OWOTHcR94pP1VkEiZacDgC/u3vdeFF3rf9OCBohPUl8KhkjW0xVH6V4fxD/XfAoPDPk/5DlVSq2YILMoguAoPfcsfPqIzvFV3+cGUMCfjtLErX9MbMPh0CJ1RHmSnXbvXhSLMMEOOWKZdBy7IhJ982bQKP+kKBy40yEGUYzwMIyYxI/Q04PPIlPrJc2ZhPtudtvBenjiWh8WUhzsaBIoistFvXPo1jp+l63v+vln5KcbfngKfx6QkOqRufAcT5xVmX2zKFWM+fBidoDxCH4hkvIhJbXPP9MWGXPovtaB5oasqE0vkmTIadHgSDDe5tST/glu170BLmYyumU9m51p0C/zJ5CYIi7w3gSmq1SIiWEI+aWl1NV/UKUrAnfkfSddxcx82Psg4aRbp9JGa4966d034SqXJzcQGQyAliDrHRj5WaS92qf+Nka70fqMjy7m0GxOoKTX5V/dRS4LWgAKzt/amn/lhq81gdPKy7pmqQ1QmArErDx6KSqqWbE7xCjEE8ElVo5gU0K+wmBvJynDns8tJOdy5oYzTC0zUtjpl+aZllVSJdfW1Lxxe6BN4scLJibCAWC8cJtx15JIhppJDVnBjQKva5H3e65DyxvICiT577GLTo2nI+0LjY8SaU8L8ekeNSGyjzbMpcPo1sHXFs3MvMV7NA8bCvdoMtOQFycqc6OXBTWJbbZpWKFOynmOV+Hw9KjFW/nGuNDiCadQ+lZ24/1+sfEmr8Lv1vAMfWtagLp44cZC81sTZqDysZpMuYQruZFVLHzPnVyUI0YcyVVN/NvRt8DpegJ25fH0co2ft4IQ5839G0Xia4qBh5mZnn9MTuy8kzQBuUnbD9sLVs4wT3w//iDs0jRN5ts+b8VM34tvLZz8fwo0FjRXHeCpiPZ8wLVM6e6o8mY3qAqgS8J15tizFGKWjqSBLE8vF90pG51+TuuuCzqKbXaiFZRiN2RXzzca/k+zePitzxkSBC5C5V4im1rFBfuOU+VOCRQcvd9AqdLwwH2OjLihewLQtGVzHsgjACBejqp1l7HdcN/YVP518HndFEX0IOiEvitV3GYEllqB0e3Px/eX4u2jkAhXrbxKRwkYrQZtrPUd+sVJm6xyXqxmLKhb2Jh+HO1fD30Lwim/vrtdcUrzv6GJo29KGXRXo196Bywkba/OWFJXczeFT9OcnJTEkNN+fVyc0BTdySH0U2fKauO8PUI3Ls3dVOJd0IP6YmnJtdFFcULfI6VD2GUk7yjfvinVBIjeAjXPyidA7FZO/GvfmHUmFV1wPsxIgU+XFsFyOVtQbo/rlyIi3pi02nOKVQrdFtEQU4OLO1CkPFXEhJRG4jo5nU6lmCRAEFFXcaWXtaTR851x1s8L6XvRND7oo4ALpmQnkt2WIZI8y5r3/NA2ixFMhsRX25uVae261uheg7bRvzJ0/Q35O/DnX6pVWW22zxgSLDD1c9kALQd7/Fpee8QM9Z8Yu6e6hRr0XyhvyohNeXL0mgl1MBqpI4xnvxyYhU64wsGR3NUfVTQRA4fKy/9A+6qCJsAhge3kMZvrmKsnUmU89HwmilzQFMQC6pAxke7Bub7k46Zw45Va/95IgLuVhfUqWTJnG+n0uqaEHRj+eAs4cDWb6a+8AaFsbEKxWbWxWEm+HI7kQZe/TTTnEhHup04pcjYf1om4+3v50R8iKqQqlhh+yWHQmh1vm/egBaxQ/A4SEkfzzNNzylwE1M1dTP4I2UR0pBqsq+6GGc1BA8uycGmIJvPKGV9XiPdONx5ak3FSOEd7QlVbfX6ymj0J+ArLKpUVLRlp/k/gPkifWoJDp8gP6x7W7291DMk++FWdWY7mMGIrtYUle+cyDMVfNBm/1FtZ73V0IJ9sUyR3XMGjMk7JV8vUe/rWtamLtmhOxP+H8JQnNzTDQHzFWvClfp0MbcHKBh/NdGOSWe45I8pxWt+x64lVUbLxvMFNqEaw3PpTsK+6imKfXKZKE4H/FJUaBv9qVFisNfeVmbFnIW5t2lf2JG5NOu4AUN6MOgr/Icl9aJxnQbeAjimAFJnnjPluLoNkVQ0r6O6pRROwLESMHt5NyxNbRHy+14TuXAqsGkE9Au3S7C4nIUlWRhev165xIFteEefq17q43uz+0CjNihUCuDKEYeUdQ1+ottpf5ruKP2fYe8A2kHOZfbOsZpjoe7qa04NJ8+OGMwxCC0lRHksUXguQ5u8KjrhLBzktb8fHgUhGqjr9um31ZtQ0GkQVpxFjKonW/k2jB7BCK8iY6pB1HaOkn1EkBDlYIJqtSB1lbWc5XlupGry7GhIgiwehhgS5GpznmCg7BgfcTQy33+WwicNvSoxR+DLjXZN/WwgF7Iy3E0lCZAPjWzztED8fxc90v0/JAZ29RMwOC2DGnHi7xQtTAFkwxBW1Psuzm8hmxJIhJy0jQXQhrMaL1nhcddiRMGQ2RsBS+v5vFRC4Pzf45C4/qyFo2erzRT5VCfpbNhXZlAYBF784esxk1k0mIHw3F4VQZkRIwDz4nJ2RxoAtQeCdAhiYZevOdCtZKQ6N83ToWT7ePuOaicLQGHLeJAyr3S9I2HahHYZx8afKRZudvXM/JAzfMYaZbO9NZWUaDds3DMX6ogG59RNCx/CLfgCMXxEjJFWu+pn6tblxgKq4o6VvdqdBXuUo1cNI4zOhDd1nszA9/QmRdfTtSXx4sKQQClZ3xHgVEmQQuNnFJHg/Ugs8RsX3UG23pZGkIdRH/NKUreI666yUKQyJ0NkRnKA3CuJAAizBNQqXVg7ZidsZdPOWTd80wvJGDW8sts227d++1CoAJ/nZPUs9qUlb+Zl5RVR4OQppYHWfSbfXN4EPXf335uSd6jKEKaKkPvXZddW+61bkF4f59pTTGFA1IXyexdBHm+dBgX2z6kGmSSukMnKeNMI1arKikhaVysI9FWU+YThoNCtlwQElDSnZ3i13HRZ8f8TpYBg0ifJq3eEMJo0sbBmNpGiodTDE6McQOJLs3G4kYJHZNO/HmW+1eBcuRDgTWMbPc86C1//Xf96gFoEghcCxnrabE11sBRL/K0EVzbBw5eOqp/luYKy8cbyYs87/7IU5AlmpAcxoulvsT4w6U03q+VbzWee1LJhsCv4TXxE/Ywfz660wZOiDEPB3fpT5EmlQmQ8Vw18+ykfQOC9Ja2/LbzVQCVzWBEgUrb7yFXfv8q7QKOq1DRctl8r/PJEmChM+T270r6/5Vi058HygfXrLUKVdM9ygova98Wm31x7QZrxTpMoVVnloUAsjeQjXX9b0T/0lWAN7hCrl5TlzMJkHWA8mvDiIlcZpCsI27eipBSj7BgDcFTLYlkGzV5mbOpx+KPu7Rc106r6vXcj7hjJzFAsNywvE23R7r9DAhkBZqMwUm0iuRLLMMR8adRW5qlGVUhF5lAQoYgf+YJUB2EaqA82VJ6zQ/b1QnKrR+TJyfqg60XNLen95LO0UzTYUE3UZVQuc3KcE+2Dkq6uF9UQW5EORBxhG+dp5YPRPcVu3j8wcWjmSWqexE0+qf10tHM6351x1yVzuJTsqLTJ0Cj0bb19Ke4/N+TNkzkQ2hcJftEt70RE19ybmlVJdiS5XMLwNG4ZSSem9qJvWO91OlVbFMkpnnhKIOYYZMV0eN7o33rIC6o6R4LU25W5aF6nqHyaR05edVNt3RkCgKo+T190wbvPZaxQlB7gtIpI7z27FwYuxwUqvVEh/bIZGIYZL6dGh1AK1we05mGK/f9iON4n3/PAWTSFrq5aCq43QbbOEADm7vXEQlW27scMYnPSvSzx4/iK2HMfQKOkKNJoYbu6A1C5cN+sqxfty1RLLBPI27/EY5iHNMk9VmWgm0OtVEh7pcfs+uh2fJrqpsCybTPB7Dm8kIdF40QdVlm6+uTZIt3jcHbjn7+OambmaJPQfC0/P2OJxvKYYNiq3vbDj+U0EzeiTqJfiSA00loS9958YuZ07mGC7woZB2m6teCTv3asE94sH7YhUCZ7XZ7oIkuZXK+KQ6VUt5gVZ4PE6GK832NCSsyenImSGklhA8TWAMGEMKiQCeQn2CGfV35or0PstRRanyiQFra/VmjEod9Tf7P/WTo9v2d4sOZtvogUPo0xd9TUwvo7LvGTvB7dHK9/B0nomnbGSY4iUebkjZcwdeKtzjSIfocQYjBUZiIdFBTFIRfan22gRE7by+9B8J83IWHjHwG0lpmysw1AgZOcXZLR2wQF7O5NdFj5BJDKXsgCoGyk6QbJbcmp2W1kPQOvTTDJSiJWng22eAUqIMKq7VekjduQOs2TssRx8vlup6KEf+4NRplN8LCIbjXGHWBvSLsd41nM7Do0s/E/anldH0xdvsjHrzGLIGX+vL9mHQmWf3RCNMFVQz3wiaKkuLV+RHzLlHfbuKy71w0Hj6CigvJ0RDWOBti5Xd58NMxrbUBP+R7XYvzeL2kfffphpWarDDSvUx06zCo/K1gVPABDsZTATgJIRTS9/Fcs+oUouuBOFeogANnFK87fkVK2Lmyzg5Rkd2tr42iv+ZrI0T3NbTRRuYKiAMuYquAutcoylJ6ruG5b7VwQHv84WQ+R5ys5a5W3f5fWDN4tx8Naeiqej/4PQ5hHBk4R1WAEmb7p4F2nojAzeHE+5goCe7faxQq7md8u5gzuEUVH1Xr+IRRwPs0t/y4+l9tdnoebsh7ZMKhx1ykc8BNg6QClF5R7z5sB79eaeKjgW+Yv2Ewst1riBOIXBHnqlNbeLdjWKUEIKIzKyxG9dYdDb9Q6jd6PLPE0aKFs7WqMjflrUQ1TrFySiyVSed12Hgg3ib0qP2HKVH2Dq9AbSl+fcrvrP4EfutJ4Naygb58wrzktx31i5WARh6dhbKZxxLnKOM4i6i7F5CXcjE1YYl5lD1tzvhNyeAebele9rMTxg1sN1tvd6pJVEJwJI4+Q3f7ZVVLdPGiiklZtY/Fkk20GKhpOOetgopMLwc40jOc3FryS3mAoFt+qdjyoGh1R+jIQb0WJZ1gWC4GaxkWaLnK2qwRXaZu+8N0FY2opeERUgBl3Jl1ojEALxXklwmJfMb7fV8FArk5plX8AYPkMYY08VEYcHJz8FOp8NPlh6myLvsC8Ye8eXUrNQBh3O8U9ECvtXW+oQ6weqUXjWRqgVR7kE7D/2povdTzVoIZrt3JKiq5kQfB1ZL36/p03slwoITsm6x7hrFq6gx1xJey1ZFZmQ5us8FlNkTYrLWSfab3E3ybJ1pA7d1RilCE8evoFk2MNbQPBwRPfdvd1rIZjzd1EcIgKHw7XbPSHp71AyTScfkLKL6E53wKPEWUbZeGMkIxkpdV71HbgoeO8J6P6zXCwNVzPaJQfEdOGTHjdS7bR1zMl0sR2/yhyHZs6Y0d9O6g/898IsKe/8/LXxR0gLesvFb1gtJBOM61biPEcFuxteTfOAfTKCVKNCC1/u/Kqd4UfGQ7M2zliaiv604Rlez5xI/jvNFGR4dWHXtO9rq10U1rsZ68vANeRiJYj/E2/IKWTml2OFVOfc3Laq4o/3F4y1m32DxOLJ8fNO7iNtZLdIiJWhL94a3KhPeDS0g/uIsLkIfp4NHsx9oS+YuIvAh7nliB3+b2Ua5ZLouTLwOSvF3rMXubJVtFbtMjrlLX4kP9DBfyUSRrKzSyBGJfK6JB6W6ua+E+Bms6BsawYXo3946qPd8SqOI7sQx1qEd3cqvgg/diT/M+vT7yJtEHvKoDuUnedPKshyKwWJkYp7dUhUyo72WgkPcOuprFDSYpWFbWlwLHK8cMIBJm2oNOpC4AdW3Qs1lFEn700iLUlmy7tJ7PsanXdeEwa8fd3ftxTD7IVd+f1N9iHgCjgM4xUScNzpJXGkc+rVO6s9zncLkRlqY0H8bY4yaPtt9AzDnm4z71oxBWMgmncocrnxTBovZfzEMraHDdhblu4YV0f1398YRIlKt3BXDdhjFciJaOZrMi68ms3h4OaNeEVcjj17IsrnZ6rmT35cdlQd/rQtL7VCkxLqR+sHbIx3cSVT3dx5t/S7HCu89bLUfDCdR3Bc8cajjef9+UehuyyVjpN7ivjXi2WbgaXWW+RxrmCNGLZ28tjAOXU0Yy3/6R8k/NDGEdblr0Kvc8U7AyKBALI4wqH3pBZ7F1Sllz48irt0ihee6Kl7k2SAW31sa2k3fe3XgFN61D9kWzXxaJBVBf2hkKVtPnLJ3Wh5n0oj3y8S17Fhj7/+vWKYS2ILqNHBvxQrwxC1NCUwZAndE0f9vcxYVYn4ErQQktnOPg4DN/WYvlzJRhx6z/G12PpO1CZ9A67RLEDf1mxveHYaLC8I60psZwSeXorINvG+nLRKfKZ63fKxQHtqL2nhsk+fVneYpLIgV5rfC3S/iu09exdEd5dm1cl/3gFeb+QDl1Iuj6h/MhfeFVTDXZQ/N+AWP1dQZmJP3LXdGPzPwv/k4KdXgKn6X4oR9YnQaRwGgsZcjcX91rst/b3LBvU6zhE1n7m6GA+39Ba9/HAgLWYRzR7pOuoPqCLnIgDa3b5lJnDsP2QMXnlqr2/y0DH3v/JRyNVJ1VbIi89v4atW317AhTweR/LOoaTjdvv0357jTYAiU3Fjjj95EXrk/2Cj1SHKOsCdCQpmd2lbjXw5E9V8kmSOJocyfQJrq8o/tYzgz8PUoa8SDVoqDwVXLF/0AgueK+dglWXMkSOdtDwhnsSIpmGP5ughnWq86Wb7lj3WcrryxPgDqAgWpmcGptu6WTR4LDQY2qaNKl7rTnf2ia6pdMZEFYs07yHttGETqbsenn99AmcxksAhpY5/YP4uItm0/v6LDsz9eF4mVDA9p1kW2UoGgf75jNPB7mZpREPqFymFRq9NYnYJet6SrK6cdnu6zDjwKscvcyNMROJiYYJclNV0BOsS1SYXTraIQ7sKwKMgGpXMeqMR2iloLX8k2h2m30lBUAxdIo0O0+7H/hT7mZInXUOC0icAK8mJ632NzAMfJ0ugraBjP5K0cwAlNtnmuZRAcvdcnWLPgZDnJiaxbcEVjIEiMeH0Llqkf4YludIQR5HmjjHdsuJTRG3rGjbhILhPVLjmDt/KaYcXh736/03OpRepCWNfK8l11dvAyxrycuhTu8a5xhJAgJA7W1eKfz9TeTz+BcbC2Wa6bNnzaSMLaItRsRjNX9RVj5J25AnbOPn4bDC2QcTs275YkdkpuQDoMWeeQzsVvdSK2X+Abtp4UJOwg+ErL0VpSyhB1cl8iIAsClocMOm9lM3xCvJ9Y/ahJpuS2LRgEYkHDmzKQ6K4fMv4KiYD4YreRbE8pfO12dq+xXlKOGG76N2+1Ax08oD6ELNh1dEbxlXNsJfaRZT2e26eg0TnsiVAO12lh+IT7UUc/54EUDMkvnJmwPdwntC34C2bW9QCPLrtBo+0jc7LLjnANAm6OMkApjLs7bugiV7of74/cXW79JIjmiRxWTvLNVMBqz2hu8B0ZOWNuWijIkTJh5U7PJscL8p0Sw9dE11NWeNuAIkAAejjoFNNQcz0E3PG96tL9v5A0M9UzxikoWP1oBuok/Sm+vOd+kF8fPo7M1qFlGw9h7GUVabpxrex9nQC+fKAYVptgQqRBa1QlCXoRbAd/dftzIR83cnhaxhxCxpIeydqm8xX/1CkKnVHT1dzLDtl4ryjTg+qaJPUfUT53AT5UYXc+oJMS2TJbLf0BRWxr1BuJxpV6d8FMI4M07rcr3bN9IRTxbHfmc9cwwUaDJbYIySla3jSUlFQuT7Viyj75KrXBNLsF15KCan7MLtV20LinFVN/5VG8E/DPRLx7e5gxOlT3MZXpbJcrArAQf+Qw9D3RaU0p9f+Z/VUUgp9C7MCVw/Qoon2eszcme2wAqnIn9CwgIHph5QiNauC6lUKo3byV4Vb4ZBTyXPXlwVZn+tTmoQspaEpQy64OhcN0CdnptsgUkgzpAtjjwhj59LjgQFsj1tEpFhNQadeKc+ovFpg1yU6c8oXTmraqe4DrfylMyjwk8w9Pug4R6OIRkUu6q5vdaLraf/qUtor650kEnkzEy9l613Mw/RSExXbnx15uJzwQBxDgNcVhW/N55I5CN/qDhBmpAxzlF4qCQ9Tc9bEWR+rtJGbdae1jS+3PN0AJZRL19Z0dQSuJtE4IoW9qTvOsZHc7zO/eHiligH3KVJ/azEtvKQNufp/K88lQ4XDPSnO6Acn/TXb3rWx/qAvfeaAxxL7C82Pj3+sNRCa3yUJLRgSmQKWqslSh7FCzkOaj1Emy9urrGfDGf3BnkALBRVuyOBojOie3Uh79CFGs+hz7HWSwQlKSVxlaLucSiPLRvFw08EFGjhSBuD7MJU0lvZb4ryjSHFZedEJbR4BZTU8A4/WRfKSvSX/vtSaFVPpKHDdkrPH1GGT0T2aqVGBLdmM96HhCHbozTL8nUpbmq78joPg7B2dMfqmRLScnt0RRoCMV1F+s1ioYTLXdI6b+Oc/Yt10GxMitJg71ubfqlQkDyp7MaD8+6QmshAzFTZ3TqkdtilYyxP8LVS76D/OxCK1KH6dOR5wBPmKQFmKdpyosKygEmaAYfo0GX6J5VIUGmpZlw0RKwaSPxHf5uyztDYvXZpnwY+cJk2R4q00kcui4Lx8uLGyDV0L60TSKY6nnAPbEzGKXyB/beWFsu1fwZTYrH9cMvU7qInmR+2EAQYrZJlMhmVaTlQrix9FKbiLIBaTfoPomq7S8eq1j5EyIG6uncaSpN4jmtCtNRruqdom8p6beOxKhaW2u72BprJ+S8gDa5054PhvdkeCdYuhMzxvE6UfzK/xJBAaA/WjLG1Mvd06X4emana5x/ogxwYOub7T4BvQ5BpNiEqfqHLdWACPOIZiz6z5rMHII/u5Ich68saaJaG8JftSzxia/Dtzr51uFcDAOB4wsjrcJUTrHYnlvYpd2MrkH8eDosBe6uHxZhEyhm4UkJ8Jpkxoez+oj1tw7FmGDNO2sC0sxMkqCQ2sQgeY2spTbk4Pz1pGmPeQwVj+JtSodY6/4Yl/iVxOjPWbytnKgZ7AG5yGn0SJvbC0y8tu6Rx2OZM2AW2oFSwaP30NLO8J6TBrkqsO+JamHH09xs5XLVwdoawhNc0RXgfyiEg34HyEpcGT1nLhsYyoOFTgYoeahDNbEEFzbjdFKOhh3/12SCKOwnSYgP+pVkPrx32Obg5idi6zGfxozJz9F8Vo3OR7bWQ3u9BFOsTFIh7yvlIScY3DOaTkqnvBoK3jhPBo5+ZY7MfUackcOO4zLK5T1GY0eWSrLSVqbcP0rCz3iC8cVnHb1ldQxa3zEwuiut1/NGO1y6BqWtt+2EYJMfTlDYuARpxYHEU1/74b9pmN/ikKz6fR36Dm/OIwo1RN3ibKMFrp6Ah/drL9jfCUHgSkF1CltvTdFPuxuUpPkueuqCYkjTL/MMbwWnwhAE4xQko4g4Bxm9gvC8MHjSGYBPM3Qq7m5lE4HSArf0RzhTXo0cEfuyVf2I8yWPxfDo8XEcZ/YJit6WkMCzhSZgOOOP3DnPqnNzakn9/kV++g7ZtH/qrZzXe0LgPPAjngNXnvt+rJifCdoH58voCCfa8VPSLrlng+p3JXKosrY4UQ4t3FURImqobuEcjxY6kJkW6K4UbPo2RzDcPPhgQdaNTSmvtduSnMz52idh1zVRl4B4grRz1bLJQ1xjs70Civ3yrwmIkdTMivkOAlBtQ58rkrE03zhvBmgSq0YzteK/ZeR/LU3GvduNLTrsGZBX4I5Wg7/1QOyqR2K1IJpQ9LSU8YPzc7o99u3fqaUD3g/xlEHyhaRjlnAMHQ6EhVQj+96CaqnhLQ5AcLb4Jxp7+CPrebfJEBY9EkRIzJMJwhVJmI9/nHHzYKPP5grWnrGj85Ss0Ckyx5OkYLTncEpJ4YaUTjgADDEcSSnA7YYI8Rq4feYG0YYYTNHAOXdfTs7VJl+D2Kn8iMyhCNYEFGLaoKcaAL2YygTchXT7RrMMu6Re6dEobGxBJ3vwOYCa7a0+K3dyyBD8YTW9aFmM/nP6b/jlVGavN+QmUAO41JDr9B9Nx/8THmX+7q8wPV5aOLb2eHaCRSsdH7s9nxzjE9gj8MooiIyFA1WA5/xk3WPeD0FH1BET4tWgvVgLQp3EFD9z7fvcw6LM5S4s1V4mTw8k2xep4bExYWSvBMmxawLKAllKpw4gIsgWjZl54Adugp9y9f8Gb0a3aCRbrPgsOmsYqKqrSNca9z47Gwhntv6VauxET+O/AmHmH2wH26NING0dOsJrxZ87DhWmCrZBMdu0zY+VBjzdsQpUBE2dJEuO84HHzmTpbNZXGiQxcZRTJglTPFufJIr6dyWYechZ608+t9yO42XkiadQWEQJworExn/Qn11WgOGAxrdMgmN8lnyQKICGCc7HXtjHFTWZyEsKz0X5/vepdFZe59mZtrm1AgDifJABhcbTODtmyltTx7ZZnyEkUN/Ws98ST92joyUiIyQtG0Nvigaqr+D0SPgMz3GdUCub0bl3gStS9p1S34mgP1rv8NWjK5kxJYi3PMCgtB9xIUmZZuZg0yQ3Fe7smA8agIEuRpK0A96aSYrJCGuSk+OuQ2OPTNuzvLSJcUDaJCFKQA9zyfGs6whw4gafZSdIs4yxiOnF++Ks0DHHCYps5m/q8F8v9Fk0vNcLHfJkiR2407P5ry3zZoAVCT+JGXxjiYhT9O/LGvpFH8Xiifj8TCXWRy/cg/rlyfdvn/S/xByRj1QSTYEfdqXmYA";

      var jsonMsg = {
        id: 1,
        license: license,
      };
      this.ws_cmd.send(JSON.stringify(jsonMsg));
    },
    //初始化CZURPlugin环境反馈，格式: {"id": 2, "error": 错误代码}
    CZUR_ID_Initialize_Response(jsonObj) {
      var error = jsonObj.error;

      switch (error) {
        case 0:
          this.txtlog = "初始化CZURPlugin成功\r\n" + this.txtlog;
          break;

        case 1:
          this.txtlog = "异常错误\r\n" + this.txtlog;
          break;

        case 3:
          this.txtlog = "系统内存不足\r\n" + this.txtlog;
          break;

        case 6:
          this.txtlog = "无效的授权码\r\n" + this.txtlog;
          break;

        case 9:
          this.txtlog = "CZURPlugin环境已初始化\r\n" + this.txtlog;
          break;

        case 42:
          this.txtlog = "创建图像处理线程失败\r\n" + this.txtlog;
          break;

        case 43:
          this.txtlog = "字符集转换失败\r\n" + this.txtlog;
          break;
      }
    },
    //清除CZURPlugin环境反馈，格式: {"id": 4, "error": 错误代码}
    CZUR_ID_Deintialize_Response(jsonObj) {
      this.txtlog = "清除CZURPlugin成功\r\n" + this.txtlog;
    },
    //拍照保存文件反馈，格式: {"id": 14, "error": 错误代码}
    CZUR_ID_GrabImage_Response(jsonObj) {
      var error = jsonObj.error;

      switch (error) {
        case 0:
          {
            this.txtlog = "拍照成功，图像正在处理，请稍后\r\n" + this.txtlog;
          }
          break;

        case 1:
          {
            this.txtlog = "异常错误\r\n" + this.txtlog;
          }
          break;

        case 3:
          {
            this.txtlog = "系统内存不足\r\n" + this.txtlog;
          }
          break;

        case 4:
          {
            this.txtlog = "录像期间，无法拍照\r\n" + this.txtlog;
          }
          break;

        case 8:
          {
            this.txtlog = "CZURPlugin环境未初始化\r\n" + this.txtlog;
          }
          break;

        case 10:
          {
            this.txtlog = "设备不支持某些拍照属性参数设置\r\n" + this.txtlog;
          }
          break;

        case 11:
          {
            this.txtlog = "无效的摄像头序号\r\n" + this.txtlog;
          }
          break;

        case 14:
          {
            this.txtlog = "摄像头尚未打开\r\n" + this.txtlog;
          }
          break;

        case 17:
          {
            this.txtlog = "无效的颜色模式\r\n" + this.txtlog;
          }
          break;

        case 18:
          {
            this.txtlog =
              "图像保存格式不合法，仅支持JPG、BMP、PNG、PDF、TIFF\r\n" +
              this.txtlog;
          }
          break;

        case 19:
          {
            this.txtlog = "激光线闪过之后，才可以拍摄下一张\r\n" + this.txtlog;
          }
          break;

        case 20:
          {
            this.txtlog = "非法TIFF压缩方式\r\n" + this.txtlog;
          }
          break;

        case 21:
          {
            this.txtlog = "无效的JPG压缩质量\r\n" + this.txtlog;
          }
          break;

        case 43:
          {
            this.txtlog = "字符集转换失败\r\n" + this.txtlog;
          }
          break;

        case 50:
          {
            this.txtlog = "图像数据尚未准备好，请稍后再试\r\n" + this.txtlog;
          }
          break;
      }
    },
    //打开设备，格式：{"id": 9, "index": 摄像头序号}
    CZUR_ID_OpenDevice() {
      //摄像头分辨率
      var width, height;
      //摄像头序号
      var index = 0;
      var jsonMsg = {
        id: 9,
        index: index,
      };
      this.ws_cmd.send(JSON.stringify(jsonMsg));
    },
    //拍照保存JPG图像数据(BASE64编码)，格式: {"id": 68, "index": 摄像头序号, "dpi": DPI, "color": 颜色模式, "round": 圆角留白, "adjust": 方向转正, "bcr": 条码识别, "bpd": 空白页检测, "quality": JPG压缩质量}
    CZUR_ID_GrabBase64() {
      //摄像头序号
      var index = 0;
      if (0 != index && 2 != index) {
        index = 1;
      }

      //DPI
      var dpi = 0;

      //色彩模式
      var color = 0;

      //圆角留白
      var round = 0;

      //方向调整
      var adjust = 0;
      //识别条码
      var bcr = 0;

      //空白页检测
      var bpd = 0;

      //JPG压缩质量
      var quality = 75;

      var jsonMsg = {
        id: 68,
        index: index,
        dpi: dpi,
        color: color,
        round: round,
        adjust: adjust,
        bcr: bcr,
        bpd: bpd,
        quality: quality,
      };
      this.ws_cmd.send(JSON.stringify(jsonMsg));
    },
    // 将处理完毕的JPG(BASE64编码)图像数据信息通知给调用者
    CZUR_ID_BASE64(jsonObj) {
      var error = jsonObj.error;
      switch (error) {
        case 0:
          {
            //图像处理成功，判断是否识别到条码
            switch (jsonObj.type) {
              case 8:
                {
                  this.txtlog =
                    "识别到条码，类型: EAN-8，内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;

              case 9:
                {
                  this.txtlog =
                    "识别到条码，类型: UPC-E，内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;

              case 12:
                {
                  this.txtlog =
                    "识别到条码，类型: UPC-A，内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;

              case 13:
                {
                  this.txtlog =
                    "识别到条码，类型: EAN-13，内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;

              case 14:
                {
                  this.txtlog =
                    "识别到条码，类型: ISBN-13，内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;

              case 25:
                {
                  this.txtlog =
                    "识别到条码，类型: Interleaved 2 of 5，内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;

              case 39:
                {
                  this.txtlog =
                    "识别到条码，类型: Code 39，内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;

              case 64:
                {
                  this.txtlog =
                    "识别到条码，类型: QR Code, 内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;

              case 128:
                {
                  this.txtlog =
                    "识别到条码，类型: Code 128，内容: " +
                    jsonObj.barcode +
                    "\r\n" +
                    this.txtlog;
                }
                break;
            }

            this.txtlog = "获取BASE64图像数据成功\r\n" + this.txtlog;
            var j_img_base64 = new Image();

            //demo中只是简单的对BASE64数据进行显示
            if (jsonObj.b641 != "null") {
              j_img_base64.crossOrigin = "anonymous";
              j_img_base64.src = "data:image/jpeg;base64," + jsonObj.b641;
              console.log(j_img_base64.src, "CZUR_ID_BASE64");
              this.confirmPic(j_img_base64.src);
            }
          }
          break;

        case 1:
          {
            this.txtlog = "发生异常错误，无法获取JPG图像数据\r\n" + this.txtlog;
          }
          break;

        case 3:
          {
            this.txtlog = "系统内存不足\r\n" + this.txtlog;
          }
          break;

        case 40:
          {
            this.txtlog =
              "图像为空白页，不保存BASE64编码数据\r\n" + this.txtlog;
          }
          break;
      }
    },
    base64ToBlob(base64) {
      const byteString = atob(base64.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: "image/jpeg" }); // 这里可以根据实际情况修改类型
    },
    //关闭设备，格式: {"id": 11, "index": 摄像头序号}
    CZUR_ID_CloseDevice() {
      //摄像头序号
      var index = 0;

      var jsonMsg = {
        id: 11,
        index: index,
      };
      this.ws_cmd.send(JSON.stringify(jsonMsg));
      this.takePhotoVisible = false
    },
    //关闭设备反馈，格式: {"id": 12, "error": 错误代码}
    CZUR_ID_CloseDevice_Response(jsonObj) {
      var error = jsonObj.error;

      switch (error) {
        case 0:
          {
            var index = 0;
            if (0 == index) {
              this.is_draw_m_frame = false;
              this.m_ctx_frame.fillStyle = "#000000";
              this.m_ctx_frame.beginPath();
              this.m_ctx_frame.fillRect(
                0,
                0,
                this.m_cav_frame.width,
                this.m_cav_frame.height
              );
              this.m_ctx_frame.closePath();
            }
            this.txtlog = "关闭摄像头成功\r\n" + this.txtlog;
            this.takePhotoVisible = false;
          }
          break;

        case 4:
          {
            this.txtlog = "正在进行录像，无法关闭设备\r\n" + this.txtlog;
          }
          break;

        case 8:
          {
            this.txtlog = "CZURPlugin环境未初始化\r\n" + this.txtlog;
          }
          break;

        case 11:
          {
            this.txtlog = "无效的摄像头序号\r\n" + this.txtlog;
          }
          break;

        case 14:
          {
            this.txtlog = "摄像头未打开\r\n" + this.txtlog;
          }
          break;
      }
    },
    queryPhoneColorList() {
      console.log(this.phoneForm.phoneName, "选择型号");
      // 创建一个新的 Axios 实例专用于 /colorListApi 请求
      const colorListApiInstance = axios.create({
        baseURL: "/colorListApi",
      });
      //使用FormData对象发送POST请求
      colorListApiInstance
        .post(
          "monkeyshop/common/searchPhoneColorByModel" +
          "?" +
          "modelName" +
          "=" +
          this.phoneForm.phoneName + "&email=" +
          this.GLOBAL.userEmail
        )
        .then((res) => {
          console.log(res, "res");
          this.phoneColorList = res.data.data.colors;
          // this.tableData = res.data.
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async print(content) {
      this.fullscreenLoading = true;
      content.elements[0].json.value = "自主维修标签"
      content.elements[1].json.value = "手机品牌：" + this.phoneForm.phoneBrand
      content.elements[2].json.value = "型号：" + this.phoneForm.phoneName
      content.elements[3].json.value = "IMEI：" + this.phoneForm.IMEIName
      content.elements[4].json.value = "原因：" + this.phoneForm.reason
      const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
      console.log(allPrintersRes, "allPrintersRes");
      try {
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info)
          const allPrintersName = Object.keys(allPrinters);
          const allPrintersValue = Object.values(allPrinters);
          console.log(allPrinters, 'allPrinters')
          console.log(allPrintersName[0], allPrintersValue[0], 'allPrintersName[0]', 'allPrinters[0]')
          const res = await this.nMPrintSocket.selectPrinter(
            allPrintersName[0],
            parseInt(allPrintersValue[0])
          );
          console.log("选择打印机", res);

          if (res.resultAck.errorCode === 0) {
            console.log("连接成功");
            const initRes = await this.nMPrintSocket.initSdk({ fontDir: "" });
            if (initRes.resultAck.errorCode == 0) {
              console.log("初始化成功");
              this.startPrintJobTest(content);
            } else {
              this.fullscreenLoading = false
              this.$notify.error({
                title: '错误',
                message: '初始化失败'
              });
              console.log("初始化失败");
            }
          } else {
            this.fullscreenLoading = false
            this.$notify.error({
              title: '错误',
              message: '连接失败'
            });
            console.log("连接失败");
            // alert("连接失败");
          }
        } else {
          this.fullscreenLoading = false
          return alert("没有在线的打印机");
        }
      } catch (err) {
        return alert(err);
      }
    },
    confirm() {
      this.$refs.originForm.validate((valid) => {
        if (valid) {
          console.log(this.originForm, 'originForm')
          if (this.originForm.afterSalesType == '返厂维修') {
            this.$router.push({ name: 'returnToFactory', params: { isReturn: '1' } });
          } else {
            this.pagestatus = false
          }
          this.originVisible = false
        } else {
          console.log('验证失败');
          return false;
        }
      });
    },
    retakePhoto() {
      console.log(this.reTakePhoneNum, "retakephoto");
      console.log("重拍");
      this.showPicPreview = false;
      if (this.reTakePhoneNum == 1) {
        this.screenData.url = "";
      } else if (this.reTakePhoneNum == 2) {
        this.backData.url = "";
      } else if (this.reTakePhoneNum == 3) {
        this.leftData.url = "";
      } else if (this.reTakePhoneNum == 4) {
        this.rightData.url = "";
      } else if (this.reTakePhoneNum == 5) {
        this.topData.url = "";
      } else if (this.reTakePhoneNum == 6) {
        this.bottomData.url = "";
      } else if (this.reTakePhoneNum == 7) {
        this.SNData.url = "";
      } else if (this.reTakePhoneNum == 8) {
        this.IMEIData.url = "";
      } else if (this.reTakePhoneNum == 9) {
        this.batteryData.url = "";
      } else if (this.reTakePhoneNum == 10) {
        this.custom1Data.url = "";
      } else if (this.reTakePhoneNum == 11) {
        this.custom2Data.url = "";
      } else if (this.reTakePhoneNum == 12) {
        this.custom3Data.url = "";
      }
    },
    handleLarge(val, photoNum) {
      console.log(val, photoNum, "handlelarge");
      this.picPreview = val;
      this.reTakePhoneNum = photoNum;
      this.showPicPreview = true;
    },
    toTakePhoto(e) {
      this.takePhotoVisible = true;
      // this.startCamera();
      console.log(e, "div编号");
      this.closeNum = e
      if (e == 1) {
        this.screenflag = true;
      } else if (e == 2) {
        this.backflag = true;
      } else if (e == 3) {
        this.leftflag = true;
      } else if (e == 4) {
        this.rightflag = true;
      } else if (e == 5) {
        this.topflag = true;
      } else if (e == 6) {
        this.bottomflag = true;
      } else if (e == 7) {
        this.SNflag = true;
      } else if (e == 8) {
        this.IMEIflag = true;
      } else if (e == 9) {
        this.batteryflag = true;
      } else if (e == 10) {
        this.custom1flag = true;
      } else if (e == 11) {
        this.custom2flag = true;
      } else if (e == 12) {
        this.custom3flag = true;
      }
    },
    // orderInfo(){
    //   const searchPhoneInfo1 = axios.create({
    //     baseURL: "/openApi",
    //   });
    //   console.log(this.phoneIMEI+"phoneIMEI")
    //   searchPhoneInfo1
    //     .get("monkeyshop/common/getOrderNoInfoByImei"+ "?" + "imei =" +
    //       this.phoneIMEI + "&userId=" +
    //       this.userId
    //     )
    //     .then((res) => {
    //       console.log(res)
    //     })
    //
    //     .catch(function (error) {
    //       console.log(error);
    //     });
    // },
    phoneIMEIIn() {
      var that = this;
      const phoneCodeList = [this.phoneIMEI]; // 只需要查询一个IMEI

      console.log(phoneCodeList, "phoneCodeList");

      // 创建请求实例
      const outBoundApiInstance = axios.create({
        baseURL: "/outBoundApi",
      });

      // 创建并行请求的数组
      const requests = phoneCodeList.map((element) => {
        // 构建第一个请求的 URL
        const phoneInfoRequest = outBoundApiInstance.post(`monkeyshop/common/getPhoneInfoByImei?imei=${element}&userId=${this.userId}`);

        // 构建第二个请求的 URL
        const orderNoRequest = outBoundApiInstance.post(`monkeyshop/common/getOrderNoInfoByImei?imei=${element}&userId=${this.userId}`);

        // 返回一个数组，其中包含两个请求
        return axios.all([phoneInfoRequest, orderNoRequest]);
      });

      // 使用 Promise.all 来并行处理所有请求
      Promise.all(requests.flat())
        .then((responses) => {
          // 处理所有响应
          responses.forEach((response, index) => {
            const [phoneInfoResponse, orderNoResponse] = response;

            // 处理第一个接口的返回数据
            let detailData = phoneInfoResponse.data.data.phoneVO;
            that.$set(that.phoneForm, "phoneBrand", detailData.phoneBrand);
            that.$set(that.phoneForm, "phoneName", detailData.phoneName);
            that.$set(that.phoneForm, "phoneColor", detailData.phoneColor);
            that.$set(that.phoneForm, "SNName", detailData.snName);
            that.$set(that.phoneForm, "IMEIName", detailData.imei);
            that.$set(that.phoneForm, "IMEI2Name", detailData.imei2);
            that.$set(that.phoneForm, "phoneMemory", detailData.phoneMemory);
            that.$set(that.phoneForm, "phoneElectricityList", detailData.phoneElectricityList);
            that.$set(that.phoneForm, "phoneOld", detailData.phoneOld);

            // 处理第二个接口的返回数据
            if (orderNoResponse.data.code === 200) {
              console.log(orderNoResponse.data.data.orderNo);
              that.phoneForm.orderId = orderNoResponse.data.data.orderNo;
            } else {
              console.log("错误");
            }
          });
        })
        .catch((error) => {
          console.log('API请求失败:', error.response ? error.response.data : error.message);
        });
    },
    detail() {
      // console.log(this.phoneForm.SNName)
      // const ID = this.phoneForm.SNName
      const id = "HSFUWEFWE23";
      // this.$router.push({name: 'staticQueryPage'});
      this.$router.push({ name: "staticQueryPage", params: { id } });
    },
    handleAvatarSuccess(file) {
      console.log(file, "file");
      var that = this;
      var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
      //定义唯一的文件名，打印出来的uid其实就是时间戳
      client()
        .put(fileName, file.file)
        .then((result) => {
          console.log(result, "result");
          that.SNData.url = result.url;
          console.log(that.SNData.url, "SNData.url");
        });
    },
    beforeAvatarUpload(file) {
      console.log(file, "beforeAvatarUploadfile");
      return;
    },
    //更新打印机列表
    async getPrinters() {
      if (!this.printSocketOpen) {
        this.fullscreenLoading = false
        return alert("打印服务未开启");
      }
      console.log("开始获取打印机");
      try {
        const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
        console.log(allPrintersRes, "allPrintersRes");
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          this.usbPrinters = { ...allPrinters };
          this.usbSelectPrinter = Object.keys(this.usbPrinters)[0];
          console.log("printers", this.usbPrinters);
        } else {
          this.fullscreenLoading = false
          this.$notify.error({
            title: '错误',
            message: '没有在线的打印机'
          });
          // alert("没有在线的打印机");
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 连接打印机
    async selectOnLineUsbPrinter() {
      if (!this.printSocketOpen) {
        this.fullscreenLoading = false
        return alert("打印服务未开启");
      }
      console.log("开始连接打印机");
      try {
        const res = await this.nMPrintSocket.selectPrinter(
          this.usbSelectPrinter,
          parseInt(this.usbPrinters[this.usbSelectPrinter])
        );
        console.log("选择打印机", res);

        if (res.resultAck.errorCode === 0) {
          console.log("连接成功");
          this.onlineUsbBool = true;
        } else {
          console.log("连接失败");
          this.onlineUsbBool = false;
          this.fullscreenLoading = false
          this.$notify.error({
            title: '错误',
            message: '连接失败'
          });
          // alert("连接失败");
        }
      } catch (err) {
        console.error(err);
      }
    },
    //初始化SDK
    async init() {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      //初始化数据
      try {
        const res = await this.nMPrintSocket.initSdk({ fontDir: "" });
        if (res.resultAck.errorCode == 0) {
          console.log("初始化成功");
          this.initBool = true;
        } else {
          console.log("初始化失败");
          this.initBool = false;
          this.fullscreenLoading = false
          this.$notify.error({
            title: '错误',
            message: '初始化失败'
          });
        }
      } catch (err) {
        console.error(err);
      }
    },
    //打印预览
    async previewTest(content) {
      console.log(this.phoneForm, '------------phoneForm-----------')
      console.log(content, '----------previewContent--------')
      console.log(this.ReturnTextPrintData, '----------this.ReturnReturnTextPrintData.--------')
      //   console.log(this.ReturnTextPrintData.elements[1].json.value,'----------ReturnReturnTextPrintData--------')
      this.ReturnTextPrintData.elements[0].json.value = "退回供应商标签"
      this.ReturnTextPrintData.elements[1].json.value = "手机品牌：" + this.phoneForm.phoneBrand
      this.ReturnTextPrintData.elements[2].json.value = "型号：" + this.phoneForm.phoneName
      this.ReturnTextPrintData.elements[3].json.value = "颜色：" + this.phoneForm.phoneColor
      this.ReturnTextPrintData.elements[4].json.value = "内存：" + this.phoneForm.phoneMemory
      // this.ReturnTextPrintData.elements[5].json.value = "序列号：" + this.phoneForm.SNName
      // this.ReturnTextPrintData.elements[6].json.value = "IMEI：" + this.phoneForm.IMEIName
      // this.ReturnTextPrintData.elements[7].json.value = "IMEI2：" + this.phoneForm.IMEI2Name
      // this.ReturnTextPrintData.elements[8].json.value = "https://monkeymemory.net/#/staticQueryPage/"+ this.phoneForm.SNName
      // this.ReturnTextPrintData.elements[8].json.value = "https://monkeymemory.net/#/staticQueryPage/" + this.phoneForm.IMEIName
      console.log(this.ReturnTextPrintData, '------------修改后的数据------------')
      if (!this.printSocketOpen) return alert("打印服务未开启");
      let contentArr = [];
      contentArr.push(this.ReturnTextPrintData);
      this.printTag(contentArr, 0, true);
      this.printVisible = true;
    },
    // 开始打印
    async startPrintJobTest(content) {
      // console.log(content,'----------打印内容-------------')
      // console.log(this.ReturnTextPrintData,'----------ReturnTextPrintData打印内容-------------')
      if (!this.printSocketOpen) return alert("打印服务未开启");
      let contentArr = [];
      contentArr.push(content);
      this.batchPrintJob(contentArr);
    },
    // 开始批量打印
    async startBatchPrintJobTest(content) {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      if (content == null || content.length == 0) {
        return;
      }
      this.batchPrintJob(content.data);
    },
    //批量打印列表数据
    async batchPrintJob(list) {
      const printQuantity =
        this.jsonObj.printerImageProcessingInfo.printQuantity;
      try {
        const startRes = await this.nMPrintSocket.startJob(
          this.density,
          this.label_type,
          this.print_mode,
          list.length * printQuantity
        );
        if (startRes.resultAck.errorCode == 0) {
          // 提交打印任务
          await this.printTag(list, 0);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 绘制打印标签
    async printTag(list, x, isPreview) {
      console.log(list, x, isPreview, "绘制打印标签isPreview");
      //设置画布尺寸
      try {
        const res = await this.nMPrintSocket.InitDrawingBoard(
          list[x].InitDrawingBoardParam
        );
        if (res.resultAck.errorCode != 0) {
          return;
        }
        // 提交打印任务
        this.printItem(list, x, list[x].elements, 0, isPreview);
      } catch (err) {
        console.error(err);
      }
    },
    async printItem(list, x, item, i, isPreview) {
      console.log(isPreview, "printItem isPreview");
      try {
        if (i < item.length) {
          let arrParse;
          switch (item[i].type) {
            case "text":
              //绘制文本
              arrParse = await this.nMPrintSocket.DrawLableText(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "qrCode":
              arrParse = await this.nMPrintSocket.DrawLableQrCode(item[i].json);
              //绘制二维码
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "barCode":
              //绘制一维码
              arrParse = await this.nMPrintSocket.DrawLableBarCode(
                item[i].json
              );
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "line":
              //绘制线条
              arrParse = await this.nMPrintSocket.DrawLableLine(item[i].json);
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "graph":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableGraph(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }

              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
            case "image":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableImage(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i, isPreview);
              break;
          }
        } else {
          console.log(isPreview, "isPreview我到这里了");
          if (isPreview) {
            console.log(isPreview, "isPreview我到这里了");
            // const res = this.nMPrintSocket.generateImagePreviewImage(8)
            // console.log(res, "generateImagePreviewImageRes");
            const res = await this.nMPrintSocket.generateImagePreviewImage(8);
            console.log(res, "----------preImgRes---------");
            //预览图生成失败退出流程
            if (res.resultAck.result != 0) {
              return;
            }
            this.previewImg =
              "data:image/jpeg;base64," +
              JSON.parse(res.resultAck.info).ImageData;
            console.log(this.previewImg, "this.previewImg请求成功");
          }
          //遍历完成，开始打印
          const commitRes = await this.nMPrintSocket.commitJob(
            null,
            JSON.stringify(this.jsonObj)
          );
          //回调页码为数据总长度且回调打印份数数据等于当前页需要打印的份数数据时，结束打印任务
          if (
            commitRes.resultAck.printQuantity == list.length &&
            commitRes.resultAck.onPrintPageCompleted ==
            this.jsonObj.printerImageProcessingInfo.printQuantity
          ) {
            //结束打印任务
            const endRes = await this.nMPrintSocket.endJob();
            if (endRes.resultAck.errorCode === 0) {
              console.log("打印完成");
              this.submitData()
            }
            return;
          }
          //回调为提交成功，同时数据未发送完成时，可继续提交数据
          if (commitRes.resultAck.errorCode === 0 && x < list.length - 1) {
            //数据提交成功，数据下标+1
            console.log("发送下一页打印数据： ");
            x++;
            await this.printTag(list, x);
          }
        }
      } catch (err) {
        console.error(err);
      }
    },

    async startCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        this.$nextTick(() => {
          const videoElement = this.$refs.videoElement;
          if (videoElement) {
            videoElement.srcObject = stream;
          }
        });
      } catch (error) {
        console.error("摄像头访问错误:", error);
      }
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },
    takePhoto() {
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let video = this.$refs.videoElement;

      // 设置 canvas 的尺寸为 video 的尺寸
      canvas.width = video.videoHeight; // 注意：宽高颠倒，因为视频被旋转了90度
      canvas.height = video.videoWidth;

      // 将视频帧绘制到 canvas 上，应用旋转
      // 注意：因为视频旋转了90度，所以绘制时需要调整
      context.translate(canvas.width / 2, canvas.height / 2); // 将旋转中心移动到 canvas 中心
      context.rotate((90 * Math.PI) / 180); // 旋转90度
      context.drawImage(video, -video.videoWidth / 2, -video.videoHeight / 2); // 绘制视频帧

      // 从 canvas 上获取图片数据
      this.photoDataUrl = canvas.toDataURL("image/png");
      if (this.photoDataUrl) {
        this.crooperoption.img = this.photoDataUrl;
        this.cropperVisible = true;
        console.log(this.crooperoption.img);
        // this.roRight()
        console.log("已经拍了照");

        // 这里可以对拍摄到的图片进行处理或保存等操作
      } else {
        console.error("还没有拍照");
      }
      // this.$refs.cropper.rotateRight()
    },
    startPrintBarcode() {
      this.barcodePrintFlag = true;
    },
    handleChange(val) {
      if (this.screenData.url) {
        this.screenData.picText = val;
      }
    },
    handleClose() {
      this.CZUR_ID_CloseDevice()
      console.log(this.closeNum, 'closeNum')
      if (this.closeNum == 1) {
        this.screenflag = false;
      } else if (this.closeNum == 2) {
        this.backflag = false;
      } else if (this.closeNum == 3) {
        this.leftflag = false;
      } else if (this.closeNum == 4) {
        this.rightflag = false;
      } else if (this.closeNum == 5) {
        this.topflag = false;
      } else if (this.closeNum == 6) {
        this.bottomflag = false;
      } else if (this.closeNum == 7) {
        this.SNflag = false;
      } else if (this.closeNum == 8) {
        this.IMEIflag = false;
      } else if (this.closeNum == 9) {
        this.batteryflag = false;
      } else if (this.closeNum == 10) {
        this.custom1flag = false;
      } else if (this.closeNum == 11) {
        this.custom2flag = false;
      } else if (this.closeNum == 12) {
        this.custom3flag = false;
      }
    },

    async confirmPic(base64img) {
      try {
        // 创建一个新的 Axios 实例专用于 /OCRApi 请求
        const ocrApiInstance = axios.create({
          baseURL: "/OCRApi",
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        const data = await this.base64ToBlob(base64img);
        // this.$refs.cropper.getCropBlob((data) => {
        console.log(base64img);
        if (this.screenflag) {
          this.$set(this.screenData, "url", base64img);
          this.screenflag = false;
          //定义唯一的文件名
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.screenData, "url", result.url);
            });
          this.screenData.name = "屏幕";
        }
        if (this.backflag) {
          this.$set(this.backData, "url", base64img);
          this.backflag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.backData, "url", result.url);
            });
          this.backData.name = "背板";
          // this.backData.url = window.URL.createObjectURL(data)
        }
        if (this.leftflag) {
          this.$set(this.leftData, "url", base64img);
          this.leftflag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.leftData, "url", result.url);
            });
          this.leftData.name = "左侧面";
        }
        if (this.rightflag) {
          this.$set(this.rightData, "url", base64img);
          this.rightflag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.rightData, "url", result.url);
            });
          this.rightData.name = "右侧面";
        }
        if (this.topflag) {
          this.$set(this.topData, "url", base64img);
          this.topflag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.topData, "url", result.url);
            });
          this.topData.name = "上面";
        }
        if (this.bottomflag) {
          this.$set(this.bottomData, "url", base64img);
          this.bottomflag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.bottomData, "url", result.url);
            });
          this.bottomData.name = "尾插面";
        }
        if (this.SNflag) {
          this.$set(this.SNData, "url", base64img);
          this.SNflag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.SNData, "url", result.url);
              this.SNData.url = result.url;
              const imageData = data;
              // 创建一个FormData对象
              const formData = new FormData();
              formData.append("file", imageData, this.SNData.name);
              console.log(formData, "formData");
              // formData.append('age', 30);
              var that = this;
              //使用FormData对象发送POST请求
              ocrApiInstance
                .post("monkeyshop/ocr/orcString", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                  // baseURL: '/OCRApi'
                })
                .then((res) => {
                  that.phoneSN = res.data.snname
                  that.$set(that.phoneForm, "phoneName", res.data.phoneName);
                  that.$set(that.phoneForm, "modelName", res.data.modelName);
                  that.$set(that.phoneForm, "SNName", res.data.snname);
                  that.$set(that.phoneForm, "phoneMemory", res.data.phoneMemory);
                  console.log(res, "SNData");
                  this.$nextTick(() => {
                    this.queryPhoneColorList();
                    this.phoneIMEIIn();
                  });
                })
                .catch(function (error) {
                  console.log(error);
                });
              console.log(this.SNData.url, "SNData.url");
            });
          this.SNData.name = "SN码";
          this.SNData.picText = this.SNData.picText;
          // this.SNData.url = window.URL.createObjectURL(data)
          // this.picList.push(this.SNData)
        }
        if (this.IMEIflag) {
          this.$set(this.IMEIData, "url", base64img);
          this.IMEIflag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.IMEIData, "url", result.url);
              // this.IMEIData.url = result.url;
              const imageData = data;
              // 创建一个FormData对象
              const formData = new FormData();
              formData.append("file", imageData, this.IMEIData.name);
              // formData.append('age', 30);
              var that = this;
              //使用FormData对象发送POST请求
              ocrApiInstance
                .post("monkeyshop/ocr/orcString", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                  // baseURL: '/OCRApi'
                })
                .then((res) => {
                  that.$set(that.phoneForm, "IMEIName", res.data.imeiname);
                  that.$set(that.phoneForm, "IMEI2Name", res.data.imei2Name);
                  that.phoneIMEI = res.data.imeiname;
                })
                .catch(function (error) {
                  console.log(error);
                });
              console.log(this.IMEIData.url, "IMEIData.url");
            });
          this.IMEIData.name = "IMEI码";
          this.IMEIData.picText = this.IMEIData.picText;
        }
        if (this.batteryflag) {
          this.$set(this.batteryData, "url", base64img);
          this.batteryflag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.batteryData, "url", result.url);
              const imageData = data;
              // 创建一个FormData对象
              const formData = new FormData();
              formData.append("file", imageData, this.batteryData.name);
              var that = this;
              //使用FormData对象发送POST请求
              ocrApiInstance
                .post("monkeyshop/ocr/orcString", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                })
                .then((res) => {
                  that.$set(
                    that.phoneForm,
                    "phoneElectricityList",
                    res.data.phoneElectricityList
                  );
                })
                .catch(function (error) {
                  console.log(error);
                });
            });
          this.batteryData.name = "电池容量";
          this.batteryData.picText = this.batteryData.picText;
        }
        if (this.custom1flag) {
          this.$set(this.custom1Data, "url", base64img);
          this.custom1flag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.custom1Data, "url", result.url);
              // this.bottomData.url = result.url;
              console.log(this.custom1Data.url, "bottomData.url");
            });
          this.custom1Data.name = "自定义图片1";
        }
        if (this.custom2flag) {
          this.$set(this.custom2Data, "url", base64img);
          this.custom2flag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.custom2Data, "url", result.url);
            });
          this.custom2Data.name = "自定义图片2";
        }
        if (this.custom3flag) {
          this.$set(this.custom3Data, "url", base64img);
          this.custom3flag = false;
          var fileName = "phone" + `${Date.parse(new Date())}` + ".jpg"; //定义唯一的文件名
          console.log(fileName, "fileName");
          client()
            .put(fileName, data)
            .then((result) => {
              console.log(result, "result");
              this.$set(this.custom3Data, "url", result.url);
            });
          this.custom3Data.name = "自定义图片3";
        }
        this.CZUR_ID_CloseDevice();
        this.takePhotoVisible = false;
      } catch (error) {
        console.error("Error uploading photo:", error);
      }
    },
    submitData() {
      var that = this;
      const outBoundApiInstance = axios.create({
        baseURL: "/outBoundApi",
        "Content-Type": "application/json",
      });
      let params = {
        userId: this.userId,
        afterSalesType: "自主维修",
        phoneBrand: that.phoneForm.phoneBrand,
        phoneModel: that.phoneForm.phoneName,
        phoneColor: that.phoneForm.phoneColor,
        imei: that.phoneForm.IMEIName,
        imei2:that.phoneForm.IMEI2Name,
        orderId: that.phoneForm.orderId,
        reason: that.phoneForm.reason,
        phone: that.phoneForm.phone,
        site: that.phoneForm.site,
      };
      outBoundApiInstance
        .post("monkeyshop/common/saveAfterSaleRecord", params)
        .then((response) => {
          console.log(response, 'response');
          that.$message({
            message: '自主维修信息提交成功',
            type: 'success'
          });
          that.phoneForm = {};
          that.screenData = {};
          that.backData = {};
          that.leftData = {};
          that.rightData = {};
          that.topData = {};
          that.bottomData = {};
          that.SNData = {};
          that.IMEIData = {};
          that.batteryData = {};
          that.custom1Data = {};
          that.custom2Data = {};
          that.custom3Data = {};
          that.phoneSN = "";
          that.fullscreenLoading = false
          that.$nextTick(() => {
            that.$refs["phoneForm"].clearValidate();
          });
          that.$forceUpdate();

        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.return-top-container {
  height: 550px;
  flex-direction: wrap;
  display: flex;
  width: 100%;
}

.left-container {
  width: 50%;
  margin: 25px;
  border: 2px solid #c0c4cc;
  /* background-color:#d9ecff; */
  border-radius: 20px;
}

.return-first-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.bottom-container_two {
  height: 430px;
  width: 100%;
  flex-direction: wrap;
  display: flex;
}

.bottom-left-container {
  width: 48%;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
  border: 2px solid #c0c4cc;
  /* background-color: #d9ecff; */
  display: flex;
  flex-direction: column;
}
.floating-link {
  position: absolute; /* 绝对定位 */
  top: 55px; /* 距离容器顶部的距离 */
  right: 135px; /* 距离容器右边的距离 */
}
.bottom-right-container {
  position: relative; /* 设置容器为相对定位 */
  /* width: 100%; */
  margin: 25px;
  margin-bottom: 0px;
  padding: 2%;
  /* margin: 0px 25px 0px 25px; */
  /* //border: 2px solid #c0c4cc; */
  /* background-color:#d9ecff; */
  background-color: #FFFFFF;
  border-radius: 20px;
}

.return-right-container {
  width: 100%;
  border: 2px solid #c0c4cc;
  /* background-color: #d9ecff; */
  margin: 25px;
  height: 80%;
  border-radius: 20px;
}

.return-img-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 50px 0px 50px;
  /* gap: 15px; */
  /* justify-content: center; */
}

.return-img-item-container {
  width: 20.2%;
  /* height: 0px; */
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
  position: relative;
}

.cropper {
  width: auto;
  height: 400px;
}

h3 {
  text-align: left;
}

h2 {
  text-align: left;
}

.content {
  /* border: solid 1px #ced4da; */
  padding: 8px;
  text-align: left;
}

.print_container_two {
  width: 100%;
  height: 40%;
}

.return-single-image {
  background-color: #e4e7ed;
  height: 280px;
  position: relative;
  /* text-align: center; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.front-text {
  font-size: 18px;
  /* 主标题字体大小 */
  margin-bottom: 8px;
  /* 和点击提示的间隔 */
}

.click-prompt {
  font-size: 14px;
  /* 提示语字体大小，小于主标题 */
  color: #888;
  /* 提示语颜色，做区分 */
  font-style: italic;
  /* 斜体，增加特别感 */
}

.cover-icon {
  position: absolute;
  opacity: 0;
  /* 默认不显示图标 */
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: scale(0);
  /* 初始缩放为0 */
}

.return-single-image:hover .cover-icon {
  opacity: 1;
  /* 悬停时显示图标 */
  transform: scale(10);
  /* 根据需要调整图标大小以覆盖整个 div */
}

.return-single-image:hover .front-text,
.return-single-image:hover .click-prompt {
  opacity: 0;
  /* 悬停时隐藏文字 */
}

.el-dialog__body {
  padding: 0px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.el-button--primary {
  color: #fff;
  background-color: #fb9337;
  border-color: #fb9337;
}

.pic-cover {
  height: 280px;
}
</style>



// WEBPACK FOOTER //
// src/views/SelfRepair.vue